module.exports = __webpack_public_path__ + "static/media/Ripple-1.7s-200px.7466db60.svg";